import type { ScheduleTreeItem } from "@/adapters/api";

export function rootStages(items: ScheduleTreeItem[]): ScheduleTreeItem[] {
	return items.filter((item) => item.depth === 0);
}

export interface LeafStage {
	stageId: string;
	name: string;
	plannedEndDate: string | null;
}

function isLeaf(items: ScheduleTreeItem[], index: number): boolean {
	const item = items[index];
	if (!item) return false;
	const next = items[index + 1];
	return !next || next.depth <= item.depth;
}

export function inProgressLeaves(items: ScheduleTreeItem[]): LeafStage[] {
	return items
		.filter(
			(item, index) => item.status === "in_progress" && isLeaf(items, index),
		)
		.map((item) => ({
			stageId: item.stage_id,
			name: item.name,
			plannedEndDate: item.own_planned_end_date ?? item.planned_end_date,
		}))
		.sort((a, b) => {
			if (a.plannedEndDate === b.plannedEndDate) return 0;
			if (a.plannedEndDate === null) return 1;
			if (b.plannedEndDate === null) return -1;
			return a.plannedEndDate < b.plannedEndDate ? -1 : 1;
		});
}
